<template>
    <v-container fluid
        :class="{
            'container-full-bg-gray': true,
            'pa-0': is_mobile,
            'rounded-mobile': is_mobile
        }">
        <v-snackbar
            v-if="screen_data"
            v-model="screen_data.snackbar.isVisible"
            :color="screen_data.snackbar.color"
            :timeout="screen_data.snackbar.timeout"
        >
            {{ screen_data.snackbar.text }}
        </v-snackbar>

        <!-- Dialog Añadir producto -->
        <AddProductDialog
            v-if="screen_data && screen_data.product"
            v-model="screen_data.showAddProductDialog"
            :product="screen_data.product"
            :tax-type="computed_tax_type"
            :tax-items="computed_tax_items"
            :type0-options="type_0_options"
            :line-retentions="line_retentions"
            :feature-cost-price="featureCostPrice"
            :loading="screen_data.loadingAddProduct"
            :allow-lines-at-zero="got_feature('feature_facturae_allow_lines_at_zero')"
            @update:product="updateDialogProduct"
            @tax-change="(rate, product) => tax_change(rate, product, false)"
            @tax-event-change="(rate, product) => tax_event_change(rate, product, false)"
            @retention-change="(rate, product) => retention_change(rate, product, false)"
            @price-change="product_list_component.updateTaxes"
            @cancel="toggleAddProductPopup(false)"
            @save="addProduct"
        />


        <v-dialog persistent max-width="500" v-model="screen_data.deletePopup">
            <v-card>
                <v-card-title>
                    <span class="primary_blue--text">Eliminar productos</span>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text>
                    <p class="text-subtitle-1 mt-4">
                        Se eliminarán permanentemente  {{ screen_data.selectedItems.length.toString() }} producto(s)
                    </p>
                </v-card-text>
                <v-card-actions class="acction_btns">
                    <v-spacer></v-spacer>
                    <v-btn outlined @click="screen_data.toggleDeletePopup(false); screen_data.setLoadingDeleteProduct(false);" class="action__btn">Cancelar</v-btn>
                    <v-btn 
                        color="primary_blue"
                        class="white--text action__btn"
                        @click="deleteProducts()"
                    >
                    Confirmar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>


        <v-dialog v-model="screen_data.dialogUploadProducts" max-width="660">
            <v-card class="rounded-lg">
                <v-card-title>
                    <span class="text-h6 primary__blue">Carga de productos por fichero excel</span>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text>
                    <v-container class="px-7">
                        <v-row>
                            <v-col align="center" class="pa-0">
                                    <v-icon color="primary_blue" size="55" class="material-symbols-outlined"> table_chart
                                    </v-icon>
                                </v-col>
                        </v-row>
                        <v-row>
                            <v-col align="center">
                                <span class="text-h6 primary__blue">Orden Cabecera</span>
                            </v-col>
                        </v-row>
                        <v-row>
                        <v-col align="center">
                            <p class="mb-0">Necesitamos la siguiente estructura</p>
                            <p class="font-weight-bold">{{ excelColumnStructure }}</p>
                        </v-col>
                        </v-row>
                
                        <span>              
                        <v-row>
                            <v-col cols="12">
                            <v-file-input
                                class="rounded-lg"
                                label="Archivo"
                                v-model="screen_data.file"
                                prepend-icon="mdi-paperclip"
                                color="primary__blue"
                                accept=" .xls, .xlsx, .xlsm, .ods"
                                :clearable="false"
                                :loading="screen_data.loadingUploadProducts"
                                :rules="[v => !!v || 'Archivo requerido']"
                                :error="screen_data.error_upload_file"
                                :error-messages="screen_data.error_message_upload_file"
                                outlined
                            ></v-file-input>
                            </v-col>
                        </v-row>
                        </span>
                    </v-container>
                </v-card-text>
                <v-card-actions class="acction_btns">
                    <v-spacer></v-spacer>
                    <v-btn outlined @click="screen_data.dialogUploadProducts = false;" class="action__btn">Cancelar</v-btn>
                    <v-btn color="primary_blue"
                        class="white--text action__btn"
                        @click="uploadProductsFile()"
                        :disabled="!screen_data.file"
                        :loading="screen_data.loadingUploadProducts">
                        Subir
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="screen_data.configurationPopup" max-width="800">
            <v-card class="rounded-lg">
                <v-card-title>
                    <span class="text-h6 primary__blue">Configuración de columnas</span>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text class="px-6 py-5">
                    <div style="display: flex; flex-direction: column; gap: 20px;">
                        <!-- Fixed Columns Section -->
                        <div>
                            <div class="config-subheader mb-3">
                                <span class="config-title">Columnas fijas</span>
                            </div>
                            
                            <v-list dense class="py-0">
                                <v-list-item
                                    v-for="(header, index) in fixedProductHeaders"
                                    :key="header.value"
                                    :style="{
                                        padding: '0',
                                        margin: '0',
                                        border: '1px solid #E4DAFF',
                                        borderTopWidth: index === 0 ? '1px' : '0',
                                        borderRadius: index === fixedProductHeaders.length - 1 ? '0 0 8px 8px' : '0',
                                        overflow: 'hidden',
                                        display: 'flex',
                                        alignItems: 'stretch',
                                        background: '#FAF8FF'
                                    }"
                                >
                                    <div :style="{
                                        flex: 1,
                                        display: 'flex',
                                        alignItems: 'center',
                                        padding: '12px 22px',
                                        background: '#FAF8FF',
                                        color: '#4F4F4F',
                                        fontFamily: 'Roboto',
                                        fontSize: '12px',
                                        fontWeight: 400,
                                        lineHeight: '16px',
                                        borderTopRightRadius: index === 0 ? '8px' : '0',
                                        borderTopLeftRadius: index === 0 ? '8px' : '0',
                                        borderBottomRightRadius: index === fixedProductHeaders.length - 1 ? '8px' : '0',
                                        borderBottomLeftRadius: index === fixedProductHeaders.length - 1 ? '8px' : '0'
                                    }">
                                        {{ header.text }}
                                    </div>
                                </v-list-item>
                            </v-list>
                        </div>

                        <!-- Additional Columns Section -->
                        <div v-if="additionalFields.length > 0">
                            <div class="config-subheader mb-3">
                                <span class="config-title">Columnas adicionales</span>
                            </div>
                            
                            <draggable v-model="additionalFields" animation="200" @end="onColumnReorder">
                                <transition-group>
                                    <div
                                        v-for="(field, index) in additionalFields"
                                        :key="field.id"
                                        :style="{
                                            padding: '0',
                                            margin: '0',
                                            border: '1px solid #E4DAFF',
                                            borderTopWidth: index === 0 ? '1px' : '0',
                                            borderRadius: index === additionalFields.length - 1 ? '0 0 8px 8px' : '0',
                                            overflow: 'hidden',
                                            display: 'flex',
                                            alignItems: 'stretch',
                                            transition: 'background 120ms ease, box-shadow 120ms ease',
                                            cursor: 'grab',
                                            background: '#FAF8FF'
                                        }"
                                    >
                                        <div :style="{
                                            flex: 1,
                                            display: 'flex',
                                            alignItems: 'center',
                                            padding: '8px 22px',
                                            background: '#FAF8FF',
                                            gap: '12px'
                                        }">
                                            <v-text-field
                                                v-model="field.name"
                                                dense
                                                hide-details
                                                outlined
                                                placeholder="Nombre de columna"
                                                :error="isDuplicateFieldName(field)"
                                                @input="onFieldNameChange(field)"
                                                style="flex: 1; font-size: 12px;"
                                            ></v-text-field>
                                        </div>

                                        <div style="display: flex; align-items: center; padding-right: 6px; background: #FAF8FF;">
                                            <v-btn icon small color="primary_blue" @click.stop="removeField(field)">
                                                <v-icon>mdi-delete</v-icon>
                                            </v-btn>
                                        </div>
                                    </div>
                                </transition-group>
                            </draggable>
                        </div>

                        <!-- Validation message -->
                        <div v-if="hasValidationErrors" class="error-message">
                            <v-icon small color="error">mdi-alert-circle</v-icon>
                            <span style="color: #f44336; font-size: 12px; margin-left: 8px;">
                                Hay nombres de columna duplicados o vacíos. Por favor, corrígelos antes de guardar.
                            </span>
                        </div>

                        <!-- Actions to add columns -->
                        <div class="config-actions-row">
                            <v-btn small outlined @click="addCustomField" class="config-action-btn">
                                <v-icon>mdi-plus-circle-outline</v-icon>
                                Añadir columna personalizada
                            </v-btn>
                        </div>
                    </div>
                </v-card-text>
                <v-card-actions class="acction_btns">
                    <v-spacer></v-spacer>
                    <v-btn outlined @click="cancelConfiguration" class="action__btn">Cancelar</v-btn>
                    <v-btn 
                        color="primary_blue"
                        class="white--text action__btn"
                        :disabled="hasValidationErrors"
                        @click="saveConfiguration()" 
                    >
                    Guardar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Dialog para mostrar errores de importación -->
        <v-dialog v-model="screen_data.import_errors_dialog" max-width="700">
            <v-card class="rounded-lg">
                <v-card-title>
                    <span class="text-h6 error--text">Errores de importación</span>
                    <v-spacer></v-spacer>
                    <v-btn icon @click="screen_data.import_errors_dialog = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text class="px-6 py-5">
                    <div v-if="screen_data.import_errors.length === 0" class="text-center py-4">
                        <p class="text-subtitle-1">No hay errores registrados.</p>
                    </div>
                    <div v-else>
                        <p class="text-subtitle-2 mb-4">
                            Se {{ screen_data.import_errors.length === 1 ? 'encontró' : 'encontraron' }} {{ screen_data.import_errors.length }} {{ screen_data.import_errors.length === 1 ? 'error' : 'errores' }} durante la importación:
                        </p>
                        <v-list dense class="py-0">
                            <v-list-item
                                v-for="(error, index) in screen_data.import_errors"
                                :key="index"
                                :style="{
                                    padding: '12px 16px',
                                    margin: '8px 0',
                                    border: '1px solid #ffcdd2',
                                    borderRadius: '8px',
                                    background: '#ffebee'
                                }"
                            >
                                <v-list-item-icon>
                                    <v-icon color="error">mdi-alert-circle</v-icon>
                                </v-list-item-icon>
                                <v-list-item-content>
                                    <v-list-item-title style="white-space: normal; font-size: 14px;">
                                        {{ formatError(error) }}
                                    </v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                        </v-list>
                    </div>
                </v-card-text>
                <v-card-actions class="acction_btns">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="primary_blue"
                        class="white--text action__btn"
                        @click="screen_data.import_errors_dialog = false"
                    >
                    Cerrar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- <app-row>
            <app-col cols="12"> -->
                <v-card width="100%" :class="{'rounded-10': true, 'pa-0': is_mobile}">
                    <v-card-title
                    :class="is_mobile ? 'invoiceable-title-mobile' : 'px-5 pb-0 d-flex align-center justify-space-between'"
                    >
                        <span > 
                            <v-btn v-if="companydb_id" icon @click="$router.push({name: 'invoice-list', params: {'companydb_id': companydb_id}})">
                                <AppIcon :src="require('../assets/back-arrow.svg')" :size="29" />
                            </v-btn>
                            <span class="primary_blue--text">Productos</span>  
                        </span>
                        <v-row class="pa-0 ma-0">
                            <v-col cols="3" class="pa-0 ma-0"> </v-col>
                            <v-col cols="9" class="pa-0 ma-0">
                                <slot name="search_right">
                                    <div align="right" class="d-flex justify-end align-center">
                                        <v-tooltip top>
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-btn @click="refreshList()" color="primary_blue" icon v-bind="attrs" v-on="on"
                                                    :loading="screen_data.loadingItems">
                                                    <v-icon>mdi-refresh</v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Actualizar</span>
                                        </v-tooltip>
                                        <v-tooltip top>
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-btn @click="toggleAddProductPopup(true)" color="primary_blue" icon v-bind="attrs" v-on="on">
                                                    <v-icon>mdi-plus</v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Añadir producto</span>
                                        </v-tooltip>
                                        <v-tooltip top>
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-btn @click="showDeletePopUp" color="primary_blue" icon v-bind="attrs" v-on="on"
                                                    :loading="screen_data.loadingDeleteProduct" :disabled="screen_data.selectedItems.length==0">
                                                    <v-icon>mdi-delete</v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Eliminar</span>
                                        </v-tooltip>


                                        <JobProgress v-if="currentCompany" v-model="screen_data.uploadProductsJobState" v-on:done="uploadProductsJobDone(true)" :job_id="screen_data.uploadProductsJobId" class="progress_circular">
                                            <template v-slot:progress>
                                                <v-progress-circular
                                                    v-if="screen_data.uploadProductsJobState==='running'"
                                                    indeterminate           
                                                    color="primary_blue"
                                                    class="progress_circle"
                                                ></v-progress-circular>
                                            </template> 
                                            <template v-slot:done>
                                                <v-tooltip top>
                                                    <template v-slot:activator="{ on, attrs }">                
                                                    <v-btn 
                                                        @click="screen_data.dialogUploadProducts=true;"
                                                        v-bind="attrs"
                                                        v-on="on"
                                                        color="primary_blue"
                                                        :loading="screen_data.loadingUploadProducts"
                                                        icon 
                                                        >
                                                        <v-icon class="material-symbols-outlined">upload_file</v-icon>                 
                                                    </v-btn>
                                                    </template>
                                                    <span>Cargar Productos desde Excel</span>
                                                </v-tooltip>
                                            </template>
                                        </JobProgress>

                                        <v-tooltip v-if="screen_data.import_errors.length > 0" bottom>
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-btn
                                                    outlined
                                                    color="red"
                                                    @click="screen_data.import_errors_dialog = true"
                                                    class="error-button text-none"
                                                    v-bind="attrs"
                                                    v-on="on"
                                                    style="height: 36px; border-radius: 20px;"
                                                >
                                                    <AppIcon :src="require('@/assets/view_errors.svg')" :size="29" class="mr-2" style="width: 24px; height: 24px;" />
                                                    Errores
                                                </v-btn>
                                            </template>
                                            <span>Ver errores de importación</span>
                                        </v-tooltip>

                                        <v-tooltip top v-if="got_feature('feature_add_columns_to_e_invoice')">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-btn @click="openConfigurationPopup" color="primary_blue"
                                                    icon v-bind="attrs" v-on="on">
                                                    <v-icon>mdi-cog-outline</v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Configuración</span>
                                        </v-tooltip>

                                    </div>
                                </slot>
                            </v-col>
                        </v-row>
                    </v-card-title>
                    
                    <v-card-text class="px-0 pt-0 card-title-footer-color">
                        <v-divider v-if="is_mobile"/>
                        <v-row :class="is_mobile ? 'pr-13': ''">
                            <app-search-bar
                              :filters="listFilters"
                              @updateObject="updateFilter"
                              @resetAllFilters="removeAllFilt"
                            />
                        </v-row>

                        <v-data-table 
                            v-if="! isMobile()"
                            v-model="screen_data.selectedItems" 
                            :items="screen_data.products"
                            :headers="visibleProductHeaders"
                            :show-select="screen_data.showSelect"
                            :loading="screen_data.loadingItems"
                            
                            :footer-props="{
                                'items-per-page-text': screen_data.footerItemsPerPageText,
                                'items-per-page-options': screen_data.footerItemsPerPageOptions,
                            }" 
                            :no-data-text="screen_data.textNoResults" 
                            :loading-text="screen_data.textLoading" 
                            fixed-header
                            :item-key="screen_data.itemKey" 
                            :mobile="screen_data.mobile"
                            :height="screen_data.tableHeight"
                            :items-per-page="screen_data.limit"
                            @update:items-per-page="updateLimit">

                            <!-- Header Personalizables -->
                            <template v-for="header in screen_data.products_headers" v-slot:[`header.${header.value}`]="{ header }">
                                <span tabindex="0">
                                    {{ header.text }}
                                </span>
                            </template>

                            <!-- Columnas Personalizables -->
                            <template v-for="header in screen_data.products_headers" v-slot:[`item.${header.value}`]="{ item }">
                                <span class="font-color">
                                    <slot v-if="header.value == 'code'" :name="header.value" v-bind="item">
                                        <input style="min-width:275px;"
                                            v-model="item[header.value]"
                                            @input="setDirty(item.id)"
                                            @change="setDirty(item.id)"
                                        /> 
                                    </slot>
                                    <slot v-else-if="header.value == 'description'" :name="header.value" v-bind="item">
                                        <input
                                            style="min-width:375px;"
                                            v-model="item[header.value]"
                                            @input="setDirty(item.id)"
                                            @change="setDirty(item.id)"
                                        />
                                    </slot>
                                    <slot v-else-if="header.value == 'cost_price'" :name="header.value" v-bind="item">
                                        <input 
                                            class="text-right"
                                            type="number"
                                            style="min-width:150px;"
                                            v-model="item[header.value]"
                                            @input="setDirty(item.id)"
                                            @change="setDirty(item.id)"
                                        />
                                    </slot>
                                    <slot v-else-if="header.value == 'price'" :name="header.value" v-bind="item">
                                        <input
                                            class="text-right"
                                            type="number"
                                            style="min-width:150px;"
                                            v-model="item[header.value]"
                                            @input="setDirty(item.id)"
                                            @change="setDirty(item.id)"
                                        />
                                    </slot>
                                    <slot v-else-if="header.value == 'taxes'" v-bind="item">
                                        <v-select
                                            style="min-width:100px;font-size: 0.875rem;"
                                            dense
                                            flat
                                            solo
                                            background-color="transparent"
                                            v-model="item.selected_tax"
                                            :items="computed_tax_items"
                                            item-text="name"
                                            item-value="value"
                                            :return-object="false"
                                            hide-details
                                            @change="(newRate) => tax_change(newRate, item, true)"
                                        ></v-select>
                                    </slot>
                                    <slot v-else-if="header.value == 'special_taxable_event'" v-bind="item">
                                        <v-select
                                            v-if="item.selected_tax == 0.0"
                                            style="min-width:100px;font-size: 0.875rem;"
                                            dense
                                            flat
                                            solo
                                            background-color="transparent"
                                            v-model="item.selected_tax_event"
                                            :items="type_0_options"
                                            :return-object="false"
                                            hide-details
                                            @change="(newRate) => tax_event_change(newRate, item, true)"
                                        ></v-select>
                                    </slot>
                                    <slot v-else-if="header.value == 'taxes_withheld'" v-bind="item">
                                        <v-select
                                            style="min-width:100px;font-size: 0.875rem;"
                                            dense
                                            flat
                                            solo
                                            background-color="transparent"
                                            v-model="item.selected_retention"
                                            :items="line_retentions"
                                            item-text="name"
                                            item-value="value"
                                            :return-object="false"
                                            hide-details
                                            @change="(newRate) => retention_change(newRate, item, true)"
                                        ></v-select>
                                    </slot>
                                    <slot v-else-if="header.value == 'discount'" :name="header.value" v-bind="item">
                                        <div class="discount-cell">
                                            <input
                                                class="text-right"
                                                type="number"
                                                style="width:60px;"
                                                v-model="item.discount"
                                                @input="setDirty(item.id)"
                                                @change="setDirty(item.id)"
                                            />
                                            <span class="discount-type-label">{{ item.discount_type === 'net' ? '€' : '%' }}</span>
                                        </div>
                                    </slot>
                                    <slot v-else-if="header.value == 'final_price'">
                                        <div  class="text-right">
                                            {{calculateFinalPrice(item) }} €
                                        </div>
                                    </slot>
                                    <slot v-else-if="isAdditionalField(header.value)" v-bind="item">
                                        <input 
                                            style="width: 80px; min-width: 80px; max-width: 80px;"
                                            :value="getAdditionalFieldValue(item, header.value)"
                                            @input="updateAdditionalFieldValue(item, header.value, $event.target.value); setDirty(item.id)"
                                        />
                                    </slot>
                                    <slot v-else :name="header.value" v-bind="item">{{item[header.value] }}</slot>
                                </span>
                            </template>
                            <!-- <template v-if="screen_data.hideHeaderCheckbox" #header.data-table-select></template> -->
                            
                            <template v-slot:item.actions="{ item }">
                                <div class="d-flex align-center">
                                
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on, attrs }">
                                            <div 
                                                @click="saveProduct(item)"
                                                @change="setDirty(item.id)"
                                                v-bind="attrs"
                                                v-on="on"
                                                color="primary"
                                                >
                                                <AppIcon :src="require('../assets/bank-save-transaction-disabled.svg')" :size="29" v-if="!isDirty(item.id)" />
                                                <AppIcon :src="require('../assets/bank-save-transaction.svg')" :size="29" v-else-if="isDirty(item.id)" />
                                                <v-progress-circular :size="15" :width="2" v-else indeterminate></v-progress-circular>
                                            </div>
                                        </template>
                                        <span>Guardar</span>
                                    </v-tooltip>
                                </div>
                            </template>

                            <!--Footer: Paginación-->
                            <template v-slot:[`footer.page-text`]="items">
                                {{ items.pageStart }} - {{ items.pageStop }} de
                                {{ items.itemsLength }}
                            </template>
                        </v-data-table>

                        <!-- MODO MOBILE -->
                        <template v-if="isMobile()">

                            <!-- LISTADO DE PRODUCTOS -->
                            <v-card
                            v-for="item in paginatedMobileItems"
                            :key="item.id"
                            class="mb-3 mx-2 pa-2"
                            elevation="1"
                            :class="{ 'selected-card': isSelected(item), 'selected': isSelected(item) }"
                            style="border-radius: 12px; border: 1px solid gray; font-size: 14px; position: relative; cursor: pointer;"
                            @click="toggleSelection(item)"
                            >
                                <v-checkbox
                                    v-if="screen_data.showSelect"
                                    v-model="screen_data.selectedItems"
                                    :value="item"
                                    hide-details
                                    dense
                                    class="ma-0 pa-0"
                                    style="position: absolute; top: 8px; right: 8px; transform: scale(0.9); z-index: 1;"
                                    @click.stop
                                />

                                <div class="mb-2">
                                    <div class="text-caption text--secondary">CÓDIGO</div>
                                    <div class="text-body-2 font-weight-medium">{{ item.code }}</div>
                                </div>

                                <div class="mb-2">
                                    <div class="text-caption text--secondary">DESCRIPCIÓN</div>
                                    <div class="text-body-2">{{ item.description }}</div>
                                </div>

                                <v-divider class="mb-3" />

                                <v-text-field
                                    v-model="item.price"
                                    type="number"
                                    label="Precio unitario"
                                    dense
                                    outlined
                                    hide-details
                                    class="mb-2"
                                    style="font-size: 14px;"
                                    @change="setDirty(item.id)"
                                />

                                <v-select
                                    v-model="item.selected_tax"
                                    :items="computed_tax_items"
                                    item-text="name"
                                    item-value="value"
                                    label="IVA/IGIC"
                                    dense
                                    outlined
                                    hide-details
                                    class="mb-2"
                                    style="font-size: 14px;"
                                    @change="(val) => tax_change(val, item, true)"
                                />

                                <v-select
                                    v-if="item.selected_tax == 0.0"
                                    v-model="item.selected_tax_event"
                                    :items="type_0_options"
                                    label="Tipo 0%"
                                    dense
                                    outlined
                                    hide-details
                                    class="mb-2"
                                    style="font-size: 14px;"
                                    @change="(val) => tax_event_change(val, item, true)"
                                />

                                <v-select
                                    v-model="item.selected_retention"
                                    :items="line_retentions"
                                    item-text="name"
                                    item-value="value"
                                    label="Retención"
                                    dense
                                    outlined
                                    hide-details
                                    class="mb-2"
                                    style="font-size: 14px;"
                                    @change="(val) => retention_change(val, item, true)"
                                />

                                <v-divider class="mb-3" />

                                <div class="mb-2">
                                    <div class="text-caption text--secondary">PRECIO FINAL</div>
                                    <div class="text-body-2 font-weight-bold">{{ calculateFinalPrice(item) }} €</div>
                                </div>

                                <v-divider class="mb-3" />

                                <div class="d-flex justify-center mt-1">
                                    <v-btn
                                    color="primary"
                                    elevation="1"
                                    height="36"
                                    min-width="100"
                                    class="text-button font-weight-bold px-5"
                                    :loading="screen_data.loadingProducts[item.id]"
                                    @click.stop="saveProduct(item)"
                                    >
                                    GUARDAR
                                    </v-btn>
                                </div>
                            </v-card>

                            <!-- PAGINACIÓN -->
                            <div class="d-flex align-center justify-center mt-4">
                                <v-btn icon :disabled="currentPageMobile <= 1" @click="currentPageMobile--">
                                    <v-icon>mdi-chevron-left</v-icon>
                                </v-btn>

                                <span class="mx-2 text-caption">{{ mobilePaginationText }}</span>

                                <v-btn icon :disabled="currentPageMobile >= totalPagesMobile" @click="currentPageMobile++">
                                    <v-icon>mdi-chevron-right</v-icon>
                                </v-btn>
                            </div>

                        </template>

                    </v-card-text>
                </v-card>
            <!-- </app-col>
        </app-row> -->
    </v-container>
</template>

<script>
import { ApiProductRepository, ApiProductConfigurationRepository } from "../modules/facturae/infra/ApiProductRepository";
import { ApiJobRepository } from '@/modules/jobs/infra/ApiJobRepository';
import {VueProductListScreenData} from '../modules/facturae/infra/VueProductListScreenData'
import AppConfirmModal from '@/components/layout/AppConfirmModal.vue'
import { mapGetters, mapActions, mapState } from "vuex";
import AppBtn from "@/components/layout/AppBtn.vue";
import AppTextField from "@/components/layout/AppTextField.vue";
import AppAutocomplete from "@/components/layout/AppAutocomplete.vue";
import { ProductListComponent } from "@/modules/facturae/app/ProductListComponent";
import AppSearchBar from '@/components/layout/AppSearchBar.vue';
import JobProgress from '@/components/JobProgress.vue';
import AddProductDialog from '@/components/AddProductDialog.vue';
import { S3Repository } from '../modules/shared/infra/S3Repository'
import awsconfig from '../aws-exports';
import draggable from "vuedraggable";


export default {
    name: "ProductList",
    components: {
        AppTextField,
        AppBtn,
        AppConfirmModal,
        AppAutocomplete,
        AppSearchBar,
        JobProgress,
        draggable,
        AddProductDialog
    },
    data() {
        const screen_data = new VueProductListScreenData();
        return {
            screen_data:screen_data,
            product_list_component:null,
            currentPageMobile: 1,
            line_retentions: [
                {name: 'N/A', value: 'na'},
                {name: '1%', value: 0.01},
                {name: '7%', value: 0.07},
                {name: '15%', value: 0.15},
                {name: '19%', value: 0.19},
            ],
            type_0_options: ['N/A','EX' ,'ISP', 'NS','INTRA.','EXPORT.'],
            visible_columns: ['code','description','price','discount','taxes','special_taxable_event','taxes_withheld','final_price','actions'],
            additionalFields: []
        };
    },
    props: {
        companydb_id: {
            type: [Number, String],
            required: true,
        },
    },
    watch: { 
        companydb_id: function() {
            this.$router.push({ 'name': 'product-list', 'params': { 'companydb_id': this.companydb_id }})
            this.product_list_component.updateProductList(this.companydb_id, this.listFilters)
        },
        'screen_data.productConfiguration': {
            handler(newConfig) {
                if (newConfig) {
                    this.loadAdditionalFields();
                }
            },
            deep: true
        }
    },
    async mounted() {
        this.creds = new AWS.CognitoIdentityCredentials({
            IdentityPoolId: awsconfig['aws_cognito_identity_pool_id']
        });
        this.creds.params.Logins = this.creds.params.Logins || {};
        this.creds.params.Logins['cognito-idp.eu-west-1.amazonaws.com/' + awsconfig['aws_user_pools_id']] = this.session_information.signInUserSession.idToken.jwtToken;
        this.creds.expired = true;
        AWS.config.update({
            region: awsconfig['aws_user_files_s3_bucket_region'],
            credentials: this.creds,
        });
        let s3_repo = new S3Repository(AWS, 'import_products')

        let product_repo = new ApiProductRepository();
        if (this.currentCompany){
            this.screen_data.tax_type = this.currentCompany.tax_type //desarrollo rapido, deberia prescindir de vuex
        }
        let jobs_repo = new ApiJobRepository()
        let product_config_repo = new ApiProductConfigurationRepository()
        this.product_list_component = new ProductListComponent(product_repo, jobs_repo, s3_repo, this.screen_data, product_config_repo)
        await this.product_list_component.updateProductList(this.companydb_id,  this.listFilters)
        if (this.got_feature('feature_add_columns_to_e_invoice')) {
            await this.product_list_component.uploadProductConfiguration(this.companydb_id)
        } else {
            await this.product_list_component.createEmptyProduct(this.companydb_id)
        }
    },
    methods: {
        isMobile() {
            return this.is_mobile || this.screen_size === 'md';
        },
        toggleSelection(item) {
            const index = this.screen_data.selectedItems.findIndex((i) => i.id === item.id);
            if (index >= 0) {
            this.screen_data.selectedItems.splice(index, 1);
            } else {
            this.screen_data.selectedItems.push(item);
            }
        },
        isSelected(item) {
            return this.screen_data.selectedItems.some(i => i.id === item.id);
        },
        ...mapActions("products", ['updateObject','removeAllFilters']), 
        async updateFilter(params){
            this.updateObject(params)
            this.product_list_component.updateProductList(this.companydb_id, this.listFilters)
        },
        async removeAllFilt(p){
            this.removeAllFilters()
            this.product_list_component.updateProductList(this.companydb_id, this.listFilters)      
        },
        refreshList() {
            this.product_list_component.updateProductList(this.companydb_id, this.listFilters)
        },
        updateLimit(value) {
            this.product_list_component.updateTableLimit(value)
        },
        calculateFinalPrice(product){
            let price = parseFloat(product.price) || 0;
            let discount = parseFloat(product.discount) || 0;
            let discounted_price;

            if (product.discount_type === 'net') {
                discounted_price = price - discount;
            } else {
                discounted_price = price * (1 - discount / 100);
            }

            let tax_amount = discounted_price * product.taxes[0].rate;
            let withheld_amount = 0;
            if (product.taxes_withheld.length){
                withheld_amount = parseFloat(product.taxes_withheld[0].amount) || 0;
            }
            console.log( 'discounted_price', discounted_price)
            console.log( 'tax_amount', tax_amount)
            console.log( 'withheld_amount', withheld_amount)
            console.log( 'final_price', (discounted_price + tax_amount - withheld_amount).toFixed(2))
            return (discounted_price + tax_amount - withheld_amount).toFixed(2);
        },
        toggleAddProductPopup(value) {
            this.screen_data.setAddProductDialogVisibility(value)
        },
        updateDialogProduct(updatedProduct) {
            Object.assign(this.screen_data.product, updatedProduct);
        },
        tax_change(newRate, product_to_update, value){
            this.screen_data.product.selected_tax = newRate;
            this.product_list_component.updateTaxes(product_to_update)
            if (value) {
                this.setDirty(product_to_update.id)
            }
        },
        retention_change(newRate, product_to_update, value){
            this.screen_data.product.selected_retention = newRate;
            this.product_list_component.updateTaxes(product_to_update)
            if (value) {
                this.setDirty(product_to_update.id)
            }
        },
        tax_event_change(newRate, product_to_update, value){
            this.screen_data.product.selected_tax_event = newRate;
            this.product_list_component.updateTaxes(product_to_update)
            if (value) {
                this.setDirty(product_to_update.id)
            }
        },
        async addProduct(product) {
            let res = await this.product_list_component.save(product)
            if (res) {
                this.toggleAddProductPopup(false)
                this.refreshList()
            }
        },
        async saveProduct(product) {
            await this.product_list_component.save(product)
        },
        isDirty(productId) {
            return this.screen_data.isDirty(productId)
        },
        setDirty(productId) {
            this.screen_data.setDirty(productId)
        },
        removeDirty(productId) {
            this.screen_data.removeDirty(productId)
        },
        isSaving(productId) {
            return this.screen_data.loadingProducts[productId] || false
        },
        showDeletePopUp() {
            this.screen_data.setLoadingDeleteProduct(true); 
            this.screen_data.toggleDeletePopup(true)
        },
        async deleteProducts() {
            this.screen_data.toggleDeletePopup(false)
            await this.product_list_component.delete(this.screen_data.selectedItems)
            this.refreshList()
        },
        async uploadProductsFile() {
            // Clear any previous errors before attempting new upload
            this.screen_data.clearImportErrors()
            await this.product_list_component.uploadProductsExcel(this.currentCompany.id, this.screen_data.file)

            // Clear the file input to allow selecting the same file again
            this.screen_data.file = null
        },
        formatError(error) {
            // If error is a string that looks like JSON, try to parse it
            if (typeof error === 'string') {
                try {
                    const parsed = JSON.parse(error)
                    if (parsed.row && parsed.error) {
                        return `Fila ${parsed.row}: ${parsed.error}`
                    }
                } catch (e) {
                    // If it's not JSON, return as is
                }
            } else if (typeof error === 'object' && error.row && error.error) {
                // If it's already an object with row and error
                return `Fila ${error.row}: ${error.error}`
            }
            return error
        },
        async uploadProductsJobDone() {
            this.product_list_component.uploadProductsDone(this.currentCompany.id, this.listFilters);
        },
        openConfigurationPopup() {
            this.loadAdditionalFields();
            this.screen_data.setConfigurationPopupVisibility(true);
        },
        async saveConfiguration() {
            if (this.hasValidationErrors) {
                return;
            }
            
            // Update screen_data configuration with reordered fields
            this.screen_data.reorderAdditionalFields(this.additionalFields);
            
            // TODO: Save to backend
            await this.product_list_component.saveProductConfiguration(
                this.companydb_id, 
                this.screen_data.productConfiguration
            );

            await this.product_list_component.uploadProductConfiguration(this.companydb_id);
            await this.product_list_component.updateProductList(this.companydb_id,  this.listFilters)
            await this.product_list_component.uploadProductConfiguration(this.companydb_id)

            this.screen_data.setConfigurationPopupVisibility(false);
            this.screen_data.success_message('Configuración guardada correctamente');
        },
        cancelConfiguration() {
            // Reload fields from screen_data to discard changes
            this.loadAdditionalFields();
            this.screen_data.setConfigurationPopupVisibility(false);
        },
        loadAdditionalFields() {
            this.additionalFields = this.screen_data.getAdditionalFields().map((f, index) => ({
                id: `field_${Date.now()}_${index}`, // ID estable que no cambia
                name: f.name,
                key: f.key,
                originalKey: f.key // Keep track of original key for validation
            }));
        },
        generateKeyFromName(name) {
            if (!name || name.trim() === '') {
                return '';
            }
            return name
                .toLowerCase()
                .trim()
                .normalize("NFD")
                .replace(/[\u0300-\u036f]/g, "") // Remove accents
                .replace(/[^a-z0-9\s]/g, '') // Remove special characters
                .replace(/\s+/g, '_'); // Replace spaces with underscores
        },
        addCustomField() {
            const fieldNumber = this.additionalFields.length + 1;
            const name = `Columna personalizada ${fieldNumber}`;
            const key = this.generateKeyFromName(name);
            
            this.additionalFields.push({
                id: `field_${Date.now()}_${fieldNumber}`, // ID único y estable
                name: name,
                key: key,
                originalKey: key
            });
        },
        removeField(field) {
            const index = this.additionalFields.findIndex(f => f.id === field.id);
            if (index > -1) {
                this.additionalFields.splice(index, 1);
            }
        },
        onFieldNameChange(field) {
            const newKey = this.generateKeyFromName(field.name);
            field.key = newKey;
        },
        onColumnReorder() {
            // Fields are already reordered in additionalFields due to v-model
        },
        isDuplicateFieldName(field) {
            const count = this.additionalFields.filter(f => f.key === field.key).length;
            return count > 1 || field.key === '';
        },
        isAdditionalField(headerValue) {
            if (!this.screen_data.productConfiguration || !this.screen_data.productConfiguration.fields) {
                return false;
            }
            return this.screen_data.productConfiguration.fields.some(f => f.key === headerValue);
        },
        getAdditionalFieldValue(item, fieldKey) {
            if (!item.additional_fields || !Array.isArray(item.additional_fields)) {
                return '';
            }
            const field = item.additional_fields.find(f => f.key === fieldKey);
            return field ? field.value : '';
        },
        updateAdditionalFieldValue(item, fieldKey, newValue) {
            if (!item.additional_fields) {
                item.additional_fields = [];
            }
            const fieldIndex = item.additional_fields.findIndex(f => f.key === fieldKey);
            
            if (fieldIndex >= 0) {
                // Update existing field
                item.additional_fields[fieldIndex].value = newValue;
            } else {
                // Add new field
                const fieldConfig = this.screen_data.productConfiguration.fields.find(f => f.key === fieldKey);
                if (fieldConfig) {
                    item.additional_fields.push({
                        key: fieldKey,
                        name: fieldConfig.name,
                        value: newValue
                    });
                }
            }
        }
    },
    computed: {
        ...mapGetters({
            got_feature: 'got_feature',
            is_mobile: 'is_mobile',
            screen_size: 'screen_size'
        }),
        ...mapGetters({ got_feature: "got_feature" }),
        ...mapGetters('products', ['listFilters']),
        ...mapState(['session_information']),  
        ...mapState([ //desarrollo rapido, deberia prescindir de vuex
			'currentCompany',
		]),

        computed_tax_type(){
            let ttype = this.screen_data.tax_type;
            if (!ttype.includes('iva') && !ttype.includes('igic')) {
                ttype = 'iva/igic';
            }
            return 'iva/igic';
            
        },
        computed_tax_items(){
            let tax_items = [{ name: '0%', value: 0.00 },{ name: '5%', value: 0.05 } ];
            if(this.computed_tax_type.includes('iva')){
                tax_items.push({ name: '21%', value: 0.21 });
                tax_items.push({ name: '10%', value: 0.10 });
                tax_items.push({ name: '4%', value: 0.04 });
                tax_items.push({ name: '21% RE 5.2%', value: 0.052 });
                tax_items.push({ name: '10% RE 1.4%', value: 0.014 });
                tax_items.push({ name: '4% RE 0.5%', value: 0.005 });
            }
            if(this.computed_tax_type.includes('igic')){
                tax_items.push({ name: '20%', value: 0.2 });
                tax_items.push({ name: '15%', value: 0.15 });
                tax_items.push({ name: '7%', value: 0.07 });
                tax_items.push({ name: '3%', value: 0.03 });
            }
            return tax_items;
        },
        some_0_tax(){
            return this.screen_data.products.some(product => product.selected_tax == 0.0);
        },
        paginatedMobileItems() {
        const start = (this.currentPageMobile - 1) * this.screen_data.limit;
        const end = start + this.screen_data.limit;
        return this.screen_data.products.slice(start, end);
        },
        totalPagesMobile() {
            return Math.ceil(this.screen_data.products.length / this.screen_data.limit);
        },
        mobilePaginationText() {
            const start = (this.currentPageMobile - 1) * this.screen_data.limit + 1;
            const end = Math.min(this.currentPageMobile * this.screen_data.limit, this.screen_data.products.length);
            const total = this.screen_data.products.length;
            return `${start} - ${end} de ${total}`;
        },
        featureCostPrice() {
            return this.got_feature('feature_product_cost_price')
        },
        visibleProductHeaders() {
            // Crear una copia de las columnas visibles para no mutar el original
            let visibleColumns = [...this.visible_columns];
            
            // Añadir cost_price si está la feature
            if (this.got_feature('feature_product_cost_price') && !visibleColumns.includes('cost_price')) {
                visibleColumns.splice(visibleColumns.length - 1, 0, 'cost_price');
            }
            
            // Añadir campos adicionales de productConfiguration solo si la feature está habilitada
            if (this.got_feature('feature_add_columns_to_e_invoice') && this.screen_data.productConfiguration && this.screen_data.productConfiguration.fields) {
                this.screen_data.productConfiguration.fields.forEach(field => {
                    if (!visibleColumns.includes(field.key)) {
                        visibleColumns.splice(visibleColumns.length - 1, 0, field.key);    
                    }
                });
            }
            
            return this.screen_data.products_headers.filter(h =>
                visibleColumns.includes(h.value)
            );
        },
        excelColumnStructure() {
            if (this.got_feature('feature_product_cost_price')) return "Código / Descripción / Precio / Impuesto (Ej.0.21) / Retención (Ej 0.07) / Precio de coste (Opcional)"
            else return "Código / Descripción / Precio / Impuesto (Ej.0.21) / Retención (Ej 0.07)"
        },
        fixedProductHeaders() {
            return this.screen_data.getFixedProductHeaders();
        },
        hasValidationErrors() {
            // Check if there are any duplicate keys or empty keys
            return this.additionalFields.some(field => this.isDuplicateFieldName(field));
        }
    },
};
</script>

<style scoped>

::v-deep .v-card__title {
    padding-top: 15px !important;
    padding-right: 15px !important;

}
.card-title-footer-color {
    background: #fafaff;
}

::v-deep .v-data-footer {
    background-color: #fafaff;
    margin-right: 0px !important;
    padding-right: 17px;
}

::v-deep .v-data-table-header>tr>th {
    background-color: var(--v-primaryLight-base) !important;
}

::v-deep .v-data-table-header>tr>th>span,
::v-deep .v-data-table-header>tr>th>div>div>div>label>span {
    color: var(--v-primary-base);
    font-size: 0.875rem;
}

.font-color {
    color: #56565b;
}

.discount-cell {
    display: flex;
    align-items: center;
    gap: 4px;
}

.discount-cell input {
    text-align: right;
}

.discount-type-label {
    font-size: 12px;
    color: #666;
    min-width: 12px;
}

::v-deep .v-data-table__wrapper>table>tbody>tr>td {
    border-bottom: none !important;
}

::v-deep tbody tr:nth-of-type(even) {
    /* 'deep-orange lighten-5' basides on material design color */
    background-color: rgba(245, 245, 245, 0.47);
}

::v-deep .v-input__prepend-inner>div>i {
    color: var(--v-primary-base);
    top: 2px;
    padding-left: 5px;
}

.text-field-size {
    font-weight: normal;
    font-size: 0.875rem;
}

::v-deep .input-search .v-input__slot::before {
    border-style: none !important;
}

::v-deep .input-search .v-text-field__slot,
::v-deep .input-search .v-input__prepend-inner,
::v-deep .input-search .v-input__slot {
    background-color: #f2f1ff !important;
}

::v-card-title .title-dialog {
    justify-content: space-around;
}

.autocomplete_field {
    border: solid 1px;
    border-color: var(--v-primary-base);
    color: transparent !important;
    height: 50px !important;
    margin: 0;
    padding: 0;
}

.acction_btns {
    display: flex !important;
    justify-content: space-between !important;
    padding: 0 36px 20px;
}

.action__btn {
    font-weight: 500;
    font-size: 14px;
    line-height: 16px;
    border-radius: 20px;
    padding: 18px !important;
    gap: 8px;
    text-transform: capitalize;
}


.cancel_button {
    border: 1px solid var(--v-primary-base);
    background-color: white !important;
    color: var(--v-primary-base);
    padding: 20px !important;
    font-size: 20px;
    text-transform: none !important;
}

.accept_button {
    border: 1px solid var(--v-primary-base);
    background-color: var(--v-primary-base) !important;
    color: white;
    padding: 20px !important;
    font-size: 20px;
    text-transform: none !important;
}

.btn-right {
    display: flex;
    justify-content: flex-end;
}

.no-underline>>>.v-text-field .v-input__control>.v-input__slot:before {
    border: none;
}
.rounded-10 {
    border-radius: 10px !important;
}

.primary_blue--text {
    color: var(--v-primary_blue-base) !important;
    font-size: 20px;
    font-weight: 600;
}

.selected-card {
  border: 2px solid #D1C4E9 !important; 
  box-sizing: border-box !important;
  border-radius: 12px;
  background-color: white !important;  
}

.selected-card.selected {
  border: 2px solid #9c27b0 !important; 
}

.v-application .text-body-2{
    font-size: 1rem !important;
}

.v-btn:not(.v-btn--round).v-size--default{
    width: fit-content;
}

.rounded-mobile {
    border-top-left-radius: 15px;
    border-top-right-radius: 15px;
}

.primary__blue {
    color: var(--v-primary_blue-base);
}

.config-subheader {
    color: #565656;
    font-family: Roboto;
    font-size: 12px;
    font-weight: 500;
}

.config-title {
    color: #565656;
    font-size: 12px;
    font-weight: 500;
    white-space: nowrap;
}

.config-actions-row {
    border-radius: 10px;
    background: #F3F3F3;
    display: flex;
    padding: 12px 16px;
    justify-content: flex-start;
}

.config-action-btn {
    display: flex;
    align-items: center;
    font-size: 13px;
    text-transform: none;
    font-weight: 500;
    padding: 0 16px !important;
    border: none !important;
    gap: 10px;
}

.config-action-btn .v-btn__content {
    gap: 10px;
}

.error-message {
    display: flex;
    align-items: center;
    padding: 12px;
    background: #ffebee;
    border-radius: 8px;
    border: 1px solid #ffcdd2;
}

.error-button {
    border-radius: 10px !important;
    border: 1.111px solid #DC0B0B !important;
    background: #FFF1F1 !important;
}
</style>

<style>
/* .container, .app-col{
    padding: 0px !important;
}
.sticky-header {
  position: sticky;
  top: 0; 
  z-index: 2
} */
</style>